import { Button, Col, Input, Modal, Row } from '@orobix/orobix-fe-components'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import useStyles from '../Annotator/Annotator.styles'
import useSettings from '../Settings/useSettings'
import useUpdateSettings from '../Settings/useUpdateSettings'

interface PrecisionAlertModalProps {
  action: 'creation' | 'download' | 'info'
  handleClose: () => void
  setParentPreference?: (newPreference: boolean) => void
}

const PrecisionAlertModal = ({
  action,
  handleClose,
  setParentPreference,
}: PrecisionAlertModalProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { settings, isFetching } = useSettings()
  const { updateSettings, inProgress } = useUpdateSettings()
  const [isCheck, setCheck] = useState(false)

  useEffect(() => {
    if (action === 'creation') {
      setCheck(!settings?.preference__show_precision_alert_on_creation)
    } else if (action === 'download') {
      setCheck(!settings?.preference__show_precision_alert_on_download)
    }
  }, [action, settings])

  const savePreference = () => {
    if (action === 'creation')
      updateSettings({
        preference__show_precision_alert_on_creation: !isCheck,
      })
    else if (action === 'download') {
      updateSettings({
        preference__show_precision_alert_on_download: !isCheck,
      })
      if (setParentPreference) {
        setParentPreference(!isCheck)
      }
    }
  }

  return (
    <Modal
      size="sm"
      onCloseRequest={() => {
        savePreference()
        handleClose()
      }}
      title={t('{{ precision }} model precision', { precision: 'FP16' })}
      footer={
        <Row noBottomPadding vAlignCenter>
          {action !== 'info' && (
            <Col className={classes.doNotShowAgainCheckbox}>
              <Input
                id="precision-alert-do-not-show-again-checkbox"
                name="precision-alert-do-not-show-again-checkbox"
                type="checkbox"
                label={t('Do not show again')}
                checked={isCheck}
                onChange={() => {
                  setCheck(!isCheck)
                }}
                disabled={inProgress || isFetching}
              />
            </Col>
          )}
          <Col>
            <Button
              onClick={() => {
                savePreference()
                handleClose()
              }}
              label={t('Close')}
              type="action"
              disabled={inProgress || isFetching}
            />
          </Col>
        </Row>
      }
    >
      <br />
      {action === 'creation' || action === 'info' ? (
        <p>
          {t(
            'The model training will be conducted using {{ precision }} precision (half-precision). This choice speeds up both training and inference processes, though it may result in slightly lower performance.',
            { precision: 'FP16' }
          )}
        </p>
      ) : (
        // action === 'download'
        <p>
          {t(
            'The model training was conducted using {{ precision }} precision (half-precision). This choice speeds up both training and inference processes, though it may result in slightly lower performance.',
            { precision: 'FP16' }
          )}
        </p>
      )}
      <br />
      <p>
        {t(
          'Furthermore, both training and inference can only be executed on hardware with a GPU, making them incompatible with the CPU-only AI-go Runtime.'
        )}
      </p>
    </Modal>
  )
}

export default PrecisionAlertModal
